module.exports = __webpack_public_path__ + "img/medal10.364edd3d.png";